/* eslint-disable @typescript-eslint/no-unused-vars */
import type {AppConfiguration} from "./app-configuration-types";
export const C: AppConfiguration = {
    package: 'cleanup',
    menu: 'single',
    profile: {
        locale: 'nb',
        currency: 'NOK',

        p_name_col_name: false,
        p_description_col_name: 'Description',

        s_col_name: 'Supplier',

        hideBuInCategorizationTable: true, // Agra has no business units

        initialGroupBySupplierInactive: true, // For sample this must always be the case
        categorizationShowFileDownload: true,

        categorizationReviewSubRowRelationData: [{
            relation: 'part',
            columns: [
                {db_column: "p_description", colSpec: {txt: 'Description', width: 250, minWidth: 100}},
                {db_column: 'id', colSpec: null}, // Required for categorizationShowFileDownload
                {db_column: 'file_name', colSpec: null}, // Required for categorizationShowFileDownload
                {db_column: "p_context_1", colSpec: {txt: 'ERP Free Text', width: 250}},
                {db_column: 'p_gl_name', colSpec: {txt: 'GL Name', width: 50}},
                {db_column: 'c_name', colSpec: {txt: 'Factory', width: 50}},
                {db_column: 'p_inv_id', colSpec: {txt: 'Invoice No', width: 20}},  // Added instead of file-column
                {db_column: 'p_ddate_1', colSpec: {txt: 'Date', width: 50}},
                {db_column: 'p_txt_2', colSpec: {txt: 'Invoice Summary', width: 150}},
                {db_column: 'p_txt_3', colSpec: {txt: 'Account name', width: 100}},
                {db_column: 'p_quantity', colSpec: {txt: 'Quantity', width: 50}},
                {db_column: 'p_unit_spend', colSpec: {txt: 'Price per Unit', width: 50}},
                {db_column: 'p_unit_measure', colSpec: {txt: 'Unit of Measurement', width: 50}},
            ]
        }, {
            relation: 'supplier',
            columns: [
                {db_column: 's_country_code', colSpec: {txt: 'Supplier Country', width: 100}},
                {db_column: 's_city', colSpec: {txt: 'Supplier City', width: 100}},
                {db_column: 's_region', colSpec: {txt: 'Supplier Region', width: 100}},
            ]
        }],
        searchConfiguration: 'default_p_desc',

        disabledCards: [
            'koi-ppv',
        ],
        disablesSupplier360ForDatabag: [
            2, // sample
        ],
        parentSupplierAltName: 'Normalized Supplier',

        enableProcChat: true,
        enableGoldenRecord: true,
    },
}
